import {ReactNode} from "react";

type Props = {
    host: boolean
    messageBody: string | ReactNode
    author: string
    hour?: string
    handleMouseUp?: () => void
};

const ChatContainerMessage = ({messageBody, host, hour = "", author, handleMouseUp}: Props) => {



    if (host) {
        return <div className="flex items-start gap-4 justify-end pl-12 " onMouseUp={handleMouseUp}>
            <div className="gap-1">

                {messageBody}
                <div className="text-xs text-muted-foreground text-end">{author} {hour}</div>
            </div>

        </div>
    }

    return <div className="flex items-start gap-2 pr-12 " onMouseUp={handleMouseUp}>
        <div className="gap-1 ">

            {messageBody}
            <div className="text-xs text-muted-foreground px-[5.2px]">{author} {hour}</div>
        </div>
    </div>
};

export default ChatContainerMessage